import {
  IFeatureModalData,
  IControlButtonTexts
} from 'module/productfeaturemodal/productfeaturemodal.types'

export const bloctoFeatureModalLink =
  'https://wallet.flow.com/post/migrating-from-blocto-to-flow-wallet'

export const bloctoFeatureModalData: IFeatureModalData[] = [
  {
    image: '/assets/Image/blocto-popup.jpg',
    tag: 'URGENT NOTICE',
    heading: 'Blocto is sunsetting their entire wallet service',
    body: 'Blocto has confirmed that they will be closing down their entire wallet service at 2pm AEDT on 19 Dec 2025. All Blocto wallet users MUST switch their wallets to NON-CUSTODIAL MODE before this or risk losing your assets permanently.'
  },
  {
    image: '/assets/Image/blocto-popup.jpg',
    tag: 'URGENT NOTICE',
    heading: 'This is outside of AFL Mint control',
    isExternalLink: true,
    body: (
      <div>
        <p>
          Due to how blockchain works, AFL Mint has no control over third-party
          wallets like Blocto and CANNOT recover any lost assets if this step is
          not completed in time.
        </p>
        <p className="mt-4">
          If you miss the deadline, your assets will{' '}
          <b>no longer be recoverable</b>.
        </p>
        <p className="mt-4">
          Follow this guide immediately{' '}
          <a
            href={bloctoFeatureModalLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {bloctoFeatureModalLink}
          </a>
          .
        </p>
      </div>
    )
  }
]

export const bloctoControlButtonTexts: IControlButtonTexts = {
  prev: 'Back',
  next: 'Next',
  end: 'Show me How'
}
